<template lang="pug">
  v-container(fluid fill-height)
    v-snackbar(v-model="showErrorSnackbar" color="error")
      span {{ errorMessage }}

    v-layout(align-center justify-center)
      v-flex(xs12 sm8 md6 lg3)
        v-card(text-xs-center ma-3)
          //v-card-title.title
          v-row.ma-0.mt-0(justify="end")
            v-col.text-start.title(cols="8" md="6" align="start")  {{ $t('toolbarPage.appTitle') }}
            v-col.text-end.title(cols="4" md="6" align="end")
              LanguageSelectionButton
          v-layout.logo(align-center justify-center)
            div
              v-responsive
                v-img.mobile-logo(alt="LM" :src="require('@/assets/1.0-single-image-banner-block-1700x385px.jpg')")
          v-card-title.title {{ $t('loginPage.loginLabel') }}
          v-row.ma-0(v-if="isInvalidToken")
            v-col.pb-0(cols="12")
              v-alert(type="error" border="top") {{ $t('errors.invalidTokenMessage') }}
          v-card-text
            v-form(v-model="formIsValid" ref="loginForm" lazy-validation @submit.prevent="onFormSubmit" :disabled="fetchInProgress")
              v-text-field.required(v-model="username" :label="`* ${$t('loginPage.userNameFieldLabel')}`" :rules="usernameValidationRules")
              v-text-field.required(
                autocomplete
                v-model="password"
                :label="`* ${$t('loginPage.passwordFieldLabel')}`"
                :append-icon="passwordFieldIcon"
                :rules="passwordValidationRules"
                :type="passwordFieldType"
                @click:append="onToggleShowPasswordClick"
              )
              v-btn.login-button(block color="primary" type="submit" :disabled="!formIsValid" :loading="fetchInProgress") {{ $t('loginPage.loginButtonLabel') }}
</template>

<script lang="ts">
import Vue from 'vue'
import {IS_INVALID_TOKEN, IS_USER_LOGGED_IN} from '@/store/getter-types'
import {AUTH_LOG_USER_IN, GET_KEY, SET_INVALID_TOKEN} from '@/store/action-types'
import { UserCredentialsPayload } from '@/types/payload'
import InvalidCredentialsError from '@/model/error/InvalidCredentialsError'
import {Component, Watch} from "vue-property-decorator";
import {Action, Getter} from "vuex-class";
import LanguageSelectionButton from "@/components/settings/LanguageSelectionButton.vue"
import i18n from "@/i18n";
@Component({
  components: {
      LanguageSelectionButton
  }
})

export default class LoginPage extends Vue {
  @Action(AUTH_LOG_USER_IN) performLogin!: { (payload: UserCredentialsPayload): Promise<void> }
  @Action(SET_INVALID_TOKEN) setInvalidToken!: { (payload: boolean): void }
  @Getter(IS_INVALID_TOKEN) isInvalidToken!: boolean

  private username: string | null = null
  private password: string | null = null
  private showPassword: boolean = false

  private usernameValidationRules: Array<Function> = [
    (v: string): boolean | string => !!v || i18n.t('validation.valueIsRequired').toString()
  ]

  private passwordValidationRules: Array<Function> = [
    (v: string): boolean | string => !!v || i18n.t('validation.valueIsRequired').toString()
  ]

  private formIsValid: boolean = false
  private showErrorSnackbar: boolean = false
  private errorMessage: string | null = null
  private fetchInProgress: boolean = false

  get isUserLoggedIn(): boolean {
    return this.$store.getters[IS_USER_LOGGED_IN]
  }

  get passwordFieldType(): string {
    return this.showPassword ? 'text' : 'password'
  }

  get passwordFieldIcon(): string {
    return this.showPassword ? 'fa-eye-slash' : 'fa-eye'
  }


  @Watch('isUserLoggedIn')
  watchIsUserLoggedIn(newVal: boolean): void {
    if (newVal) {
      this.$router.push({name: 'Dashboard'})
    }
  }


  onToggleShowPasswordClick(): void {
    this.showPassword = !this.showPassword
  }

  onFormSubmit(): void {
    const form: any = this.$refs['loginForm']

    if (form.validate()) {
      const payload: UserCredentialsPayload = {
        username: this.username!,
        password: this.password!
      }
      this.fetchInProgress = true
      this.setInvalidToken(false)

      this.$store.dispatch(AUTH_LOG_USER_IN, payload)
        .then(() => {
        this.$store.dispatch(GET_KEY)
      })
          .catch((e: InvalidCredentialsError) => {
            this.errorMessage = e.message
            this.showErrorSnackbar = true
            this.fetchInProgress = false
          })
      }
    }

}
</script>

<style lang="stylus" scoped>
  html
    overflow hidden !important

    .login-button
      margin-top 2em
      height 3.5em

    .title
      padding 16px 16px 0
      text-align center
      justify-items center

    .mobile-logo
      width 100%
      height 220px

    .logo
      margin 5px 20px
      padding 5px 20px
      overflow hidden

    .foot
      text-align center

  @media (max-height: 600px)
    .mobile-logo
      width 60px
      height 60px

    .welcome-text
      font-size 0.8em

  @media (max-height: 400px)
    .welcome-text
      display none
</style>
